import { LkpOfferListState } from './duck';
import { createSelector } from '~/helpers/util/selectors';

export const getRoot = (state: any) => {
  return state.ui.lkpOfferList as LkpOfferListState;
};

export const getIsLoading = createSelector(
  [getRoot],
  state =>
    state.fetchInitStatus === 'pending' ||
    state.fetchFiltersStatus === 'pending' ||
    state.fetchWorkSheetStatus === 'pending' ||
    state.fetchLkpOffersStatus === 'pending' ||
    state.fetchProductGroupsStatus === 'pending' ||
    state.fetchProductsStatus === 'pending'
);

export const getFetchStatus = createSelector([getRoot], state => {
  return state.fetchInitStatus;
});

export const getSelectedWeek = createSelector([getRoot], state => {
  return state.selectedWeek;
});

export const getReloadOffers = createSelector([getRoot], state => {
  return state.reloadOffers;
});

export const getFetchProductsPackingSummary = createSelector(
  [getRoot],
  state => {
    return state.productPackingSummary;
  }
);

export const getFetchSaveChanges = createSelector([getRoot], state => {
  return state.fetchSaveChanges;
});

export const getFetchFiltersStatus = createSelector([getRoot], state => {
  return state.fetchFiltersStatus;
});

export const getFetchLkpOffersStatus = createSelector([getRoot], state => {
  return state.fetchLkpOffersStatus;
});

export const getPageNumber = createSelector([getRoot], state => {
  return state.pageNumber;
});

export const getPageSize = createSelector([getRoot], state => state.pageSize);

export const getFetchWorkSheetInit = createSelector(
  [getRoot],
  state => state.fetchWorkSheetInit
);

export const getFetchWorkSheetStatus = createSelector(
  [getRoot],
  state => state.fetchWorkSheetStatus
);

export const getTotalCount = createSelector(
  [getRoot],
  state => state.totalCount
);

export const getErrorMessage = createSelector([getRoot], state => {
  return state.errorMessage;
});

export const getFetchHistoryStatus = createSelector([getRoot], state => {
  return state.fetchHistoryStatus;
});

export const getLkpOfferHistory = createSelector([getRoot], state => {
  return state.lkpOfferHistory;
});

export const getFetchGfpsStatus = createSelector([getRoot], state => {
  return state.fetchGfpsStatus;
});

export const getLkpOfferGfps = createSelector([getRoot], state => {
  return state.lkpOfferGfps;
});

export const getSelectedSiteId = createSelector([getRoot], state => {
  return state.siteId;
});

export const getTotalCountGfps = createSelector([getRoot], state => {
  return state.totalCountGfps;
});

export const getSelectedWeekId = createSelector([getRoot], state => {
  return state.weekId;
});
export const getConfirmSaveLkp = createSelector(
  [getRoot],
  state => state.confirmSaveLkp
);

export const getFetchLkpOffersParams = createSelector([getRoot], state => {
  return state.fetchLkpOffersParams;
});
